// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2966240","885":"6b049e79"}[chunkId] + ".chunk.js";
};